export default {
  list: [],
  listLoading: true
}
